import { render, staticRenderFns } from "./navApp.vue?vue&type=template&id=247dec8e&scoped=true"
import script from "./navApp.vue?vue&type=script&lang=js"
export * from "./navApp.vue?vue&type=script&lang=js"
import style0 from "./navApp.vue?vue&type=style&index=0&id=247dec8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247dec8e",
  null
  
)

export default component.exports